import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_EVENT_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchEventRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { EVENT_SOURCE_CHECKBOX_OPTIONS } from '#/utils/constants/general/eventSources';

type Props = {
  variant: SearchRefinementVariant;
};

export function EventSourceFacet({ variant }: Props) {
  const { i18n } = useI18n();
  const selectedFacetValues = useSearchFacetSelectedValues('source');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="source"
      icon="sign-path"
      label={
        <>
          {SEARCH_EVENT_REFINEMENT_LABELS(i18n).source}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="source"
        initialValue={selectedFacetValues}
        searchable
        options={EVENT_SOURCE_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
